import HeroSection from "./HeroSection";
import DevelopmentProcess from './DevelopmentProcess';
import ServicePreview from "./ServicePreview";
import LatestProject from './LatestProject';
import ClientList from './ClientList';

const HomePage = () => {
    return (
        <>
            <HeroSection />
            <ServicePreview />
            <DevelopmentProcess />
            <LatestProject />
            <ClientList />
        </>
    );
};

export default HomePage;